import styled from '@emotion/styled';
import { HAIRSP } from '@racemap/utilities/consts/characters';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Progress } from 'antd';
import type { FC } from 'react';
import { IconPlug } from '../Icon';

interface Props {
  batteryPercentage: number;
  isCharging?: boolean;
  isActive?: boolean;
}

export const BatteryIndicator: FC<Props> = ({
  isCharging = false,
  isActive = true,
  batteryPercentage,
}) => {
  const color = getProgressBarColor(batteryPercentage, isActive);
  const colorCharger = getChargerColor(isCharging, isActive);
  return (
    <Container>
      <Plug color={colorCharger} title="tracker charging" />
      <Progress
        percent={batteryPercentage}
        strokeColor={color}
        status={isCharging && isActive ? 'active' : 'normal'}
        trailColor={RacemapColors.LightGray}
        format={() => `${Math.round(batteryPercentage)}${HAIRSP}%`}
      />
    </Container>
  );
};

const Plug = styled(IconPlug)<{ color: string }>`
  margin-right: 5px;
  color: ${({ color }) => color};
  width: 20px;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  width: 100%;
`;

const getProgressBarColor = (batteryPercentage: number, isActive: boolean): string => {
  if (!isActive) return RacemapColors.DarkGray;

  if (batteryPercentage > 90) return RacemapColors.DarkGreen;
  if (batteryPercentage > 25) return RacemapColors.DarkYellow;
  return RacemapColors.DarkRed;
};

const getChargerColor = (isCharging: boolean, isActive: boolean): string => {
  if (!isActive && isCharging) return RacemapColors.DarkGray;
  if (isCharging) return RacemapColors.DarkGreen;
  return RacemapColors.LightGray;
};
